export default {
  sections: [
    {
      id: 19,
      isRequired: false,
      isShownInSections: true,
      taskName: "Onboarding",
      name: "Royal Mail Forms",
      link: "royal-mail-onboarding",
      iconName: "onboarding",
      carouselDisplay: "Onboarding Tasks",
      description:
        "Read and complete the policies and forms required to start work",
      status: null,
      fields: [],
      buttonType: "secondary",
      buttonText: "View",
      customIcon: "onboarding",
      updateable: true,
    },
    {
      id: 14,
      isRequired: false,
      taskName: "BasicInfo",
      name: "Address",
      iconName: "",
      carouselDisplay: "Address",
      description: "",
      status: null,
      fields: [
        "address.addressLine1",
        "address.town",
        "address.county",
        "address.postcode",
      ],
    },
    {
      id: 13,
      isRequired: false,
      taskName: "BasicInfo",
      name: "Mobile Telephone Number",
      iconName: "",
      carouselDisplay: "Mobile Telephone Number",
      description: "",
      status: null,
      fields: ["mobileTelephone"],
    },
    {
      id: 12,
      isRequired: false,
      taskName: "BasicInfo",
      name: "Date of Birth",
      iconName: "",
      carouselDisplay: "Date Of Birth",
      description: "",
      status: null,
      fields: ["dateOfBirth"],
    },
    {
      id: 11,
      isRequired: false,
      taskName: "ProfileImage",
      name: "Profile Image",
      iconName: "",
      carouselDisplay: "Profile Image",
      description: "",
      status: null,
      isPopupOnMobile: true,
      link: "accountSettings?openProfileImage",
      fields: ["profileImage"],
    },
    {
      id: 6,
      isRequired: true,
      isShownInSections: true,
      taskName: "PayrollInformation",
      name: "Payroll Information",
      iconName: "card",
      carouselDisplay: "Payroll Information",
      description:
        "You will not be able to apply for temp jobs until we have details of the account in which you'd like to be paid.",
      status: null,
      fields: [
        "bankName",
        "sortCode",
        "accountName",
        "accountNumber",
        "nationalInsuranceNo",
        "taxTypeEmployeeStatement",
      ],
    },
    {
      id: 0,
      isRequired: false,
      isShownInSections: true,
      taskName: "Onboarding",
      link: "Onboarding",
      name: "Onboarding",
      iconName: "onboarding",
      carouselDisplay: "Onboarding Tasks",
      description:
        "Read and complete the policies and forms required to start work",
      status: null,
      buttonType: "secondary",
      buttonText: "View",
      customIcon: "onboarding",
      fields: [],
      updateable: true,
      showWhen: ({ tempWorkSeeking, responsibleTeam }) =>
        tempWorkSeeking && responsibleTeam === "LIVX",
    },
    {
      id: 20,
      isRequired: false,
      isShownInSections: true,
      taskName: "Onboarding",
      name: "Driving Onboarding",
      link: "driving-onboarding",
      iconName: "onboarding",
      carouselDisplay: "Onboarding Tasks",
      description:
        "Read and complete the policies and forms required to start work",
      status: null,
      buttonType: "secondary",
      buttonText: "View",
      customIcon: "onboarding",
      fields: [],
      updateable: true,
    },
    {
      id: 15,
      isRequired: false,
      isShownInSections: true,
      taskName: "Bookings",
      name: "Bookings",
      iconName: "",
      carouselDisplay: "Bookings",
      description: "See your bookings details and calendar",
      status: "CONTINUAL",
      buttonType: "secondary",
      buttonText: "View",
      customIcon: "calendar",
      fields: [],
      updateable: true,
    },
    {
      id: 16,
      isRequired: false,
      isShownInSections: true,
      taskName: "Timesheets",
      name: "Timesheets",
      iconName: "clock",
      carouselDisplay: "Timesheets",
      description: "Fill out your timesheets",
      status: "CONTINUAL",
      fields: [],
    },
    {
      id: 32,
      isRequired: false,
      isShownInSections: true,
      taskName: "Shifts",
      name: "Shifts",
      iconName: "calendar",
      carouselDisplay: "Shifts",
      description: "Fill out your shifts",
      status: "CONTINUAL",
      fields: [],
    },
    {
      id: 31,
      isRequired: false,
      isShownInSections: false,
      taskName: "Payslips",
      name: "Payslips",
      description: "View / download your payslips",
      fields: [],
      updateable: false,
    },
    {
      id: 34,
      isRequired: false,
      isShownInSections: true,
      taskName: "Great Bear Induction Pack",
      name: "Great Bear Induction Pack",
      iconName: "onboarding",
      link: "OnboardingGB",
      carouselDisplay: "Great Bear Induction Pack",
      description:
        "Read and complete the policies and forms required to start work",
      status: null,
      fields: [],
      buttonType: "secondary",
      buttonText: "View",
      customIcon: "onboarding",
      updateable: true,
    },
    {
      id: 36,
      isRequired: false,
      isShownInSections: true,
      taskName: "Dnata Onboarding",
      name: "Dnata Onboarding",
      iconName: "onboarding",
      link: "dnata-onboarding",
      carouselDisplay: "Dnata Onboarding",
      description: "",
      status: null,
      fields: [],
      buttonType: "secondary",
      buttonText: "View",
      customIcon: "onboarding",
      updateable: true,
    },
    {
      id: 37,
      isRequired: false,
      isShownInSections: true,
      taskName: "Kingspan Onboarding",
      name: "Kingspan Onboarding",
      iconName: "onboarding",
      link: "kingspan-onboarding",
      carouselDisplay: "Kingspan Onboarding",
      description: "",
      status: null,
      fields: [],
      buttonType: "secondary",
      buttonText: "View",
      customIcon: "onboarding",
      updateable: true,
    },
    {
      id: 39,
      isRequired: false,
      isShownInSections: true,
      taskName: "Pecan Deluxe Candy Induction",
      name: "Pecan Deluxe Candy Induction",
      iconName: "onboarding",
      link: "onboarding-pecan",
      carouselDisplay: "Pecan Deluxe Candy Induction",
      description: "",
      status: null,
      fields: [],
      buttonType: "secondary",
      buttonText: "View",
      customIcon: "onboarding",
      updateable: true,
    },
    {
      id: 40,
      isRequired: false,
      isShownInSections: true,
      taskName: "Swissport Onboarding",
      name: "Swissport Onboarding",
      iconName: "onboarding",
      link: "swissport-onboarding",
      carouselDisplay: "Swissport Onboarding",
      description: "",
      status: null,
      fields: [],
      buttonType: "secondary",
      buttonText: "View",
      customIcon: "onboarding",
      updateable: true,
    },
    {
      id: 41,
      isRequired: false,
      isShownInSections: true,
      taskName: "Gate Group Onboarding",
      name: "Gate Group Onboarding",
      iconName: "onboarding",
      link: "gate-group-onboarding",
      carouselDisplay: "Gate Group Onboarding",
      description: "",
      status: null,
      fields: [],
      buttonType: "secondary",
      buttonText: "View",
      customIcon: "onboarding",
      updateable: true,
    },
    {
      id: 44,
      isRequired: false,
      isShownInSections: true,
      taskName: "Pusterla Pollards Training Pack",
      name: "Pusterla Pollards Training Pack",
      iconName: "onboarding",
      link: "pusterla-onboarding",
      carouselDisplay: "Pusterla Pollards Training Pack",
      description: "",
      status: null,
      fields: [],
      buttonType: "secondary",
      buttonText: "View",
      customIcon: "onboarding",
      updateable: true,
    },
    {
      id: 45,
      isRequired: false,
      isShownInSections: true,
      taskName: "ABM Onboarding",
      name: "ABM Onboarding",
      iconName: "onboarding",
      link: "ABM-onboarding",
      carouselDisplay: "ABM Onboarding",
      description: "",
      status: null,
      fields: [],
      buttonType: "secondary",
      buttonText: "View",
      customIcon: "onboarding",
      updateable: true,
    },
    {
      id: 46,
      isRequired: false,
      isShownInSections: true,
      taskName: "Carlton Forest Induction",
      name: "Carlton Forest Induction",
      iconName: "onboarding",
      link: "carlton-forest-onboarding",
      carouselDisplay: "Carlton Forest Induction",
      description: "",
      status: null,
      fields: [],
      buttonType: "secondary",
      buttonText: "View",
      customIcon: "onboarding",
      updateable: true,
    },
    {
      id: 47,
      isRequired: false,
      isShownInSections: true,
      taskName: "Regatta Onboarding",
      name: "Regatta Onboarding",
      iconName: "onboarding",
      link: "regatta-onboarding",
      carouselDisplay: "Regatta Onboarding",
      description: "",
      status: null,
      fields: [],
      buttonType: "secondary",
      buttonText: "View",
      customIcon: "onboarding",
      updateable: true,
    },
    {
      id: 48,
      isRequired: false,
      isShownInSections: true,
      taskName: "Stronger Together Disclaimer",
      name: "Stronger Together Disclaimer",
      iconName: "onboarding",
      link: "stronger-together",
      carouselDisplay: "Stronger Together Disclaimer",
      description: "",
      status: null,
      fields: [],
      typeCode: "YS01",
      buttonType: "secondary",
      buttonText: "Download",
      customIcon: "onboarding",
      isDownload: true,
      updateable: true,
    },
    {
      id: 49,
      isRequired: false,
      isShownInSections: true,
      taskName: "nhs-referencing",
      name: "NHS Referencing",
      iconName: "references",
      link: "nhs-referencing",
      carouselDisplay: "NHS Referencing",
      description: "",
      status: null,
      fields: [],
    },
    {
      id: 50,
      isRequired: false,
      isShownInSections: true,
      taskName: "umbrella-declaration",
      name: "Umbrella Declaration",
      iconName: "onboarding",
      link: "umbrella-declaration",
      carouselDisplay: "Umbrella Declaration",
      description: "",
      status: null,
      fields: [],
      isDownload: true,
      typeCode: "YUMB",
      fileName: "Declaration Form.pdf",
    },
    {
      id: 51,
      isRequired: false,
      isShownInSections: true,
      taskName: "CPI Onboarding",
      name: "CPI Onboarding",
      iconName: "onboarding",
      link: "cpi-onboarding",
      carouselDisplay: "CPI Onboarding",
      description: "",
      status: null,
      fields: [],
      buttonType: "secondary",
      buttonText: "View",
      customIcon: "onboarding",
      updateable: true,
    },
    {
      id: 52,
      isRequired: false,
      isShownInSections: true,
      taskName: "Thanet District Council",
      name: "Thanet District Council",
      iconName: "onboarding",
      link: "thanet-council-onboarding",
      carouselDisplay: "Thanet District Council",
      description: "",
      status: null,
      fields: [],
      buttonType: "secondary",
      buttonText: "View",
      customIcon: "onboarding",
      updateable: true,
    },
    {
      id: 53,
      isRequired: false,
      isShownInSections: true,
      taskName: "Molecular Onboarding",
      name: "Molecular Onboarding",
      iconName: "onboarding",
      link: "molecular-onboarding",
      carouselDisplay: "Molecular Onboarding",
      description: "",
      status: null,
      fields: [],
      buttonType: "secondary",
      buttonText: "View",
      customIcon: "onboarding",
      updateable: true,
    },
    {
      id: 54,
      isRequired: false,
      isShownInSections: true,
      taskName: "Compleat Food Onboarding",
      name: "Compleat Food Onboarding",
      iconName: "onboarding",
      link: "compleat-food-onboarding",
      carouselDisplay: "Compleat Food Onboarding",
      description: "",
      status: null,
      fields: [],
      buttonType: "secondary",
      buttonText: "View",
      customIcon: "onboarding",
      updateable: true,
    },
    {
      id: 55,
      isRequired: false,
      isShownInSections: true,
      taskName: "Woodland Group Onboarding",
      name: "Woodland Group Onboarding",
      iconName: "onboarding",
      link: "woodland-group-onboarding",
      carouselDisplay: "Woodland Group Onboarding",
      description: "",
      status: null,
      fields: [],
      buttonType: "secondary",
      buttonText: "View",
      customIcon: "onboarding",
      updateable: true,
    },
    {
      id: 56,
      isRequired: false,
      isShownInSections: true,
      taskName: "GrowUp Farms Induction Pack",
      name: "GrowUp Farms Induction Pack",
      iconName: "onboarding",
      link: "grow-up-farms-onboarding",
      carouselDisplay: "GrowUp Farms Induction Pack",
      description: "",
      status: null,
      fields: [],
      buttonType: "secondary",
      buttonText: "View",
      customIcon: "onboarding",
      updateable: true,
    },
    {
      id: 57,
      isRequired: false,
      isShownInSections: true,
      taskName: "Davin Foods Induction Pack",
      name: "Davin Foods Induction Pack",
      iconName: "onboarding",
      link: "davin-foods-onboarding",
      carouselDisplay: "Davin Foods Induction Pack",
      description: "",
      status: null,
      fields: [],
      buttonType: "secondary",
      buttonText: "View",
      customIcon: "onboarding",
      updateable: true,
    },
  ],
};
